import { Auth0Client, createAuth0Client } from "@auth0/auth0-spa-js";
import { IAuth0Provider, IAuth0User } from "./IAuth0Provider";
import { appContext } from "../AppContext";

export class Auth0Provider implements IAuth0Provider
{
    private auth0Client?: Auth0Client;

    public get domain(): string
    {
        return appContext().localStorageProvider.getAuth0Config().domain;
    }

    private set domain(value: string)
    {
        const config = appContext().localStorageProvider.getAuth0Config();
        config.domain = value;
        appContext().localStorageProvider.setAuth0Config(config);
    }

    public get clientId(): string
    {
        return appContext().localStorageProvider.getAuth0Config().clientId;
    }

    private set clientId(value: string)
    {
        const config = appContext().localStorageProvider.getAuth0Config();
        config.clientId = value;
        appContext().localStorageProvider.setAuth0Config(config);
    }

    public async initialise(domain: string, clientId: string): Promise<void>
    {
        this.domain = domain;
        this.clientId = clientId;

        this.auth0Client = await createAuth0Client({
            domain: this.domain,
            clientId: this.clientId,
            authorizationParams: {
                redirect_uri: window.location.origin + '/auth',
            },
        });
    }

    public async tryInitialise(): Promise<void>
    {
        if (!this.domain || !this.clientId)
        {
            return;
        }
        await this.initialise(this.domain, this.clientId);
    }

    public async login(email: string): Promise<void>
    {
        if (!this.auth0Client)
        {
            throw new Error('Call initialise() first.');
        }

        await this.auth0Client.loginWithPopup({
            authorizationParams: {
                login_hint: email,
            },
        });
    }

    public async getToken(): Promise<string>
    {
        if (!this.auth0Client)
        {
            throw new Error('Call initialise() first.');
        }
        //return this.auth0Client.getTokenSilently();
        const claims = await this.auth0Client.getIdTokenClaims();
        return claims?.__raw ?? ''; // ID token
    }

    public async getUser(): Promise<IAuth0User | undefined>
    {
        if (!this.auth0Client)
        {
            throw new Error('Call initialise() first.');
        }
        return this.auth0Client.getUser();
    }
}
